import { render, staticRenderFns } from "./PeopleImages.vue?vue&type=template&id=555ab9ac&"
import script from "./PeopleImages.vue?vue&type=script&lang=js&"
export * from "./PeopleImages.vue?vue&type=script&lang=js&"
import style0 from "./PeopleImages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports